import { camelCase } from '../../../../../shared/string-manipulations';

const getPhaseBanner = ({ price_phase, phases }) => {
  if (!phases || !phases?.[camelCase(price_phase)]) {
    return '';
  }
  const endDate = phases?.lastChance?.endDateStr || '';
  const [, month, date] = endDate.split('/');
  return `Registration Ends ${month}/${date}`;
};

export default getPhaseBanner;
